import { render, staticRenderFns } from "./VLandLeaseForm.vue?vue&type=template&id=2077bf7a&"
import script from "./VLandLeaseForm.vue?vue&type=script&lang=js&"
export * from "./VLandLeaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports